import { Flex, Box, ClickableBox } from 'components/ui';
import Tooltip from 'react-tooltip';
import infoIcon from 'img/info.svg';

const MintingDetails = () => (
  <Flex fontSize="24px" alignCenter>
    <Box mr={3}>Minting Details</Box>
    <ClickableBox pt="8px" data-for="minting_details" data-tip>
      <img src={infoIcon} alt="Info" width="24px" />
    </ClickableBox>
    <Tooltip id="minting_details" place="top" effect="solid">
      <Box maxWidth="480px">
        <Box mb={1}>The base price of a Remix mint is 0.005 ETH</Box>
        <Box mb={1}>Holders of one or more Futura Mixpass NFTs are entitled to a 25% discount. This reduces the base price to 0.00375 ETH.</Box>
        <Box mb={1}>Remixers may elect to burn either one or both of the source input remixes for further discounts.</Box>
        <Box mb={1}>Burning one input mix reduces the Remix mint price to 0.0025 ETH.</Box>
        <Box mb={1}>Burning both input mixes reduces the Remix mint price to zero.</Box>
        <Box mb={1}>Futura Masters cannot be burnt!</Box>
        <Box>The Mixpass discount does not stack with the burning discount.</Box>
      </Box>
    </Tooltip>
  </Flex>
);

export default MintingDetails;
